import { render, staticRenderFns } from "./GenericJournalCard.vue?vue&type=template&id=c6a727be&scoped=true"
import script from "./GenericJournalCard.vue?vue&type=script&lang=js"
export * from "./GenericJournalCard.vue?vue&type=script&lang=js"
import style0 from "./GenericJournalCard.vue?vue&type=style&index=0&id=c6a727be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a727be",
  null
  
)

export default component.exports